import { render } from "./Slide.vue?vue&type=template&id=c3ef6db4"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=c3ef6db4&lang=scss"
script.render = render

export default script